<template>
    <ul class="record_list">
        <li v-for="(item,index) in recordList" :key="index" class="record_item">
            <span>{{item.num}}</span>
            <span>{{item.label}}</span>
        </li>
    </ul>
</template>
<script>
export default {
    name:'RecordList',
    props:{
        recordList:{
            type:Array,
            default:()=>{
                return []
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.record_list{
    display: flex;
    margin-bottom: 30px;
    .record_item{
        font-size: 14px;
        color: #222222;
        text-align: center;
        margin-bottom: 15px;
        margin-left: 49px;
        &:first-of-type{
            margin-left: 0;
        }
        span{
            display: block;
            &:first-child{
                font-size: 36px;
                font-family: Bertha;
                font-weight: 400;
                color: #1d4434;
            }
        }
    }
}
</style>